<template>
  <div id="right">
    <div class="product" v-if="product">

      <TitlePrevNext :obj="product" />

      <!-- <h2>{{product.caption}}</h2> -->
      <p>{{product.details}}</p>

      <!-- <p v-if="hasPerspectiveClass" class="ctext">hover over card</p> -->
      <div class="flip-box">
      <img v-if="hasPerspectiveClass" class="colorcore" src="/static/images/product/icons/flip2.svg">
      <img class="card-image" :class="product['class']" :src="product.src">
      </div>

      <div class="product-details">
        <div class="icon-section">

          <!-- Caliper icons -->

          <div class="icon-wrapper" v-if="showIcon('11pt')">
            <img class="icons" src="/static/images/product/icons/caliper.svg">
            <div class="icon-text">11 pt paper</div>
          </div>
          <div class="icon-wrapper" v-if="showIcon('13pt')">
            <img class="icons" src="/static/images/product/icons/caliper.svg">
            <div class="icon-text">13 pt paper</div>
          </div>
          <div class="icon-wrapper" v-if="showIcon('14pt')">
            <img class="icons" src="/static/images/product/icons/caliper.svg">
            <div class="icon-text">14 pt paper</div>
          </div>
          <div class="icon-wrapper" v-if="showIcon('16pt')">
            <img class="icons" src="/static/images/product/icons/caliper.svg">
            <div class="icon-text">16 pt paper</div>
          </div>
          <div class="icon-wrapper" v-if="showIcon('18pt')">
            <img class="icons" src="/static/images/product/icons/caliper.svg">
            <div class="icon-text">38 pt paper</div>
          </div>
          <div class="icon-wrapper" v-if="showIcon('32pt')">
            <img class="icons" src="/static/images/product/icons/caliper.svg">
            <div class="icon-text">32 pt paper</div>
          </div>
          <div class="icon-wrapper" v-if="showIcon('34pt')">
            <img class="icons" src="/static/images/product/icons/caliper.svg">
            <div class="icon-text">34 pt paper</div>
          </div>
          <div class="icon-wrapper" v-if="showIcon('15mil')">
            <img class="icons" src="/static/images/product/icons/caliper.svg">
            <div class="icon-text">15 mil plastic</div>
          </div>

          <!-- Color-core icons - core -->

          <div class="icon-wrapper" v-if="showIcon('black')">
            <img class="icons" src="/static/images/product/icons/core.svg">
            <div class="icon-text">black center</div>
          </div>
          <div class="icon-wrapper" v-if="showIcon('blue')">
            <img class="icons" src="/static/images/product/icons/core.svg">
            <div class="icon-text">blue center</div>
          </div>
          <div class="icon-wrapper" v-if="showIcon('red')">
            <img class="icons" src="/static/images/product/icons/core.svg">
            <div class="icon-text">red center</div>
          </div>
          <div class="icon-wrapper" v-if="showIcon('aqua')">
            <img class="icons" src="/static/images/product/icons/core.svg">
            <div class="icon-text">aqua center</div>
          </div>
          <div class="icon-wrapper" v-if="showIcon('orange')">
            <img class="icons" src="/static/images/product/icons/core.svg">
            <div class="icon-text">orange center</div>
          </div>

          <!-- Appearance icons - bright, glossy, linen -->

          <div class="icon-wrapper" v-if="showIcon('white')">
            <img class="icons" src="/static/images/product/icons/bright.svg">
            <div class="icon-text">bright white</div>
          </div>
          <div class="icon-wrapper" v-if="showIcon('gloss')">
            <img class="icons" src="/static/images/product/icons/gloss.svg">
            <div class="icon-text">high gloss finish</div>
          </div>
          <div class="icon-wrapper" v-if="showIcon('linen')">
            <img class="icons" src="/static/images/product/icons/linen.svg">
            <div class="icon-text">linen texture</div>
          </div>
           <div class="icon-wrapper" v-if="showIcon('vellum')">
            <img class="icons" src="/static/images/product/icons/vellum.svg">
            <div class="icon-text">vellum texture</div>
          </div>
          <div class="icon-wrapper" v-if="showIcon('raised')">
            <img class="icons" src="/static/images/product/icons/raised.svg" id="raised">
            <div class="icon-text">raised print</div>
          </div>
          <div class="icon-wrapper" v-if="showIcon('pearl')">
            <img class="icons" src="/static/images/product/icons/pearl.svg" id="pearl">
            <div class="icon-text">iridescent finish</div>
          </div>
          <div class="icon-wrapper" v-if="showIcon('soft')">
            <img class="icons" src="/static/images/product/icons/soft.svg" id="soft">
            <div class="icon-text">soft to the touch</div>
          </div>
          <div class="icon-wrapper" v-if="showIcon('plastic')">
            <img class="icons" src="/static/images/product/icons/plastic.svg" id="plastic">
            <div class="icon-text">waterproof</div>
          </div>

          <!-- Usse case icons - ink coverage, color, photos, sturdy, type, write -->

          <div class="icon-wrapper" v-if="showIcon('ink')">
            <img class="icons" src="/static/images/product/icons/ink.svg">
            <div class="icon-text">heavy coverage</div>
          </div>
          <div class="icon-wrapper" v-if="showIcon('color')">
            <img class="icons" src="/static/images/product/icons/color.svg">
            <div class="icon-text">saturated color</div>
          </div>
          <div class="icon-wrapper" v-if="showIcon('hybrid')">
            <img class="icons" src="/static/images/product/icons/knife.svg">
            <div class="icon-text">versatile</div>
          </div>
          <div class="icon-wrapper" v-if="showIcon('photo')">
            <img class="icons" src="/static/images/product/icons/photo.svg">
            <div class="icon-text">great for photos</div>
          </div>
          <div class="icon-wrapper" v-if="showIcon('extra')">
            <img class="icons" src="/static/images/product/icons/extra.svg">
            <div class="icon-text">extra thick paper</div>
          </div>
          <div class="icon-wrapper" v-if="showIcon('sturdy')">
            <img class="icons" src="/static/images/product/icons/sturdy.svg">
            <div class="icon-text">sturdy</div>
          </div>
          <div class="icon-wrapper" v-if="showIcon('font')">
            <img class="icons" src="/static/images/product/icons/font.svg">
            <div class="icon-text">crisp type</div>
          </div>
          <div class="icon-wrapper" v-if="showIcon('magnet')">
            <img class="icons" src="/static/images/product/icons/magnet.svg" id="magnet">
            <div class="icon-text">magnetic backer</div>
          </div>
          <div class="icon-wrapper" v-if="showIcon('write')">
            <img class="icons" src="/static/images/product/icons/pencil.svg" id="write">
            <div class="icon-text">write on me</div>
          </div>
          <!-- End icons -->
        </div>
      </div>
    </div>
    <QtyPriceForm class="qtybox" v-if="product" :paper="product.apiName || product.name" />
  </div>

</template>

<style lang="scss" scoped>
@import '~scss/colors.scss';

// RIGHT SIDE
.product-details {
  position: relative;
  width: 100%;
  height: calc(100vh - 580px);
}

.icon-section {
  display: flex;
  justify-content: space-between;
  margin: 0 auto;
  max-width: 504px;
}
 @media (max-width: 992px) {
  .icon-section {
     max-width: 450px;
  }
 }
 @media (max-width: 768px) {
  .icon-section {
     max-width: 380px;
  }
 }

.icon-wrapper {
  position: relative;
  display: inline-block;
  text-align: center;
  width: 120px;
  height: 100px;
  opacity: 0.5;
}
 @media (max-width: 992px) {
  .icon-wrapper {
      height: 80px;
      width: 100px;
  }
 }
  @media (max-width: 768px) {
  .icon-wrapper {
      height: 70px;
      width: 90px;
  }
 }


.icons {
  position: absolute;
  bottom: 2em;
  left: 0;
  right: 0;
  margin: 0 auto;
  box-shadow: none;
  width: 30%;
  max-height: 30px;
}

#raised {
  max-height: 25px;
}

.icon-text {
  position: absolute;
  display: inline-block;
  bottom: 0;
  left: 0;
  right: 0;
  margin: 0 auto;
  font-size: 14px;
  color: $black-0;
}
 @media (max-width: 768px) {
  .icon-text {
    font-size: 12px;
  }
 }

#right {
  height: 100%;
  position: relative;
  display: flex;
  margin-bottom: 0;
}
.qtybox {
  max-width: 300px;
}

// Extra small devices (portrait phones, less than 576px)
@media only screen and (max-width: 992px) {
  #right {
    flex-direction: column;
    padding-right: 0;
    padding-left: 0;
    margin: 0;
    align-items: stretch;
  }
  .qtybox {
    max-width: initial;
  }
  @media (max-height: 800px) {
    .product-details {
      display: none;
    }
  }
  .product-details {
    height: auto;
  }

}


// Product area

#back-button {
  padding: 0.5em 0 0 1.5em;
  font-size: 14px;
  line-height: 16px;
  color: $black-1;
}

.product {
  position: relative;
  flex-grow: 1;
  background:$frost-1;
  perspective: 1000px;
}

#right h1 {
  font-size: 24px;
  padding: 6px 0;
  color: $black-1;
  text-align: center;
}

#right p {
  font-size: 16px;
  color: #595b5b;
  max-width: 504px;
  margin: 0 auto;
  text-align: center;
}
@media (max-width: 992px) {
  #right p {
    font-size: small;
    max-width: 450px;
  }
}
  @media (max-width: 576px) {
  #right p {
    max-width: 90%;
  }
}


.card-image {
  margin: 3em auto 0 auto;
  max-width: 504px;
}

@media (max-width: 992px) {
  .card-image {
    position: initial;
    max-width: 400px;
    margin: 1em auto;
    z-index: 10;
  }
}

@media (max-width: 768px) {
  .card-image {
    position: initial;
    max-width: 325px;
    margin: 1em auto;
    z-index: 10;
  }
}

.flip-box{
  width:100%;
  max-width: 600px;
  margin:0 auto;
}
@media (max-width: 992px) {
  .flip-box {
    max-width: 420px;
  }
}

.colorcore {
  position: absolute;
  top:35%;
  box-shadow:none;
  opacity:.5;
  width:35px;
}
@media (max-width: 414px) {
  .colorcore {
   display:none;
  }
}

img {
  display: block;
  padding: 0;
  box-shadow: 5px 5px 10px rgba(0, 0, 0, 0.5);

  &.perspective:hover {
    // add perspective to images on hover
    cursor: pointer;
    transform: rotateY(45deg);
    transition: transform 2s ease-in-out;
    box-shadow: -20px 20px 50px rgba(0, 0, 0, 0.5);
    border-left: solid #7a7a7a;

    &.black-edge {
      border-left-color: black;
      outline: 2px solid $white;
    }
    &.red-edge {
      border-left-color: red;
      outline: 2px solid $white;
    }
    &.blue-edge {
      border-left-color: blue;
      outline: 2px solid $white;
    }
    &.aqua-edge {
      border-left-color: aqua;
      outline: 2px solid $white;
    }
    &.orange-edge {
      border-left-color: orange;
      outline: 2px solid $white;
    }
  }
}
</style>

<script>
import QtyPriceForm from "./QtyPriceForm";

export default {
  props: ["product"],
  components: {
    QtyPriceForm
  },
  computed: {
    hasPerspectiveClass() {
      let classStr = this.product["class"] || "";
      return classStr.match(/\bperspective\b/);
    }
  },
  methods: {
    showIcon(tag) {
      let p = this.product;
      return p && p.tags && p.tags.includes(tag);
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/pages/homepage/businesscards/shared/ProductPanel.vue